<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<p class="dedit"><em class="italic">Dedicated to my headmaster who introduced me to the pleasures of the theatre and equipped me with the necessary writing and analytical skills that I would employ thirty years later as an author. Thank you for being such a kind-hearted, dedicated, charismatic, influential teacher. It was a joy and privilege to be one of your students.</em></p>
<p class="dedi"><em class="italic">Lionel Warne</em></p>
<p class="dedi"><em class="italic">1942–2020</em></p>
<p class="dedit"><em class="italic">And in loving memory of my dear friend and shipmate</em></p>
<p class="dedi"><em class="italic">Judith Brocklehurst</em></p>
<p class="dedi"><em class="italic">1973–2018</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Dedicated.vue?5a1d2240